import React from 'react'

export const CreateProjectContext = React.createContext({})
